module.exports = __webpack_public_path__ + "static/img/bg4.1073a354.png";